<div id="wrapper">
  <!-- <app-navbar></app-navbar> -->

  <app-sidebar></app-sidebar>

  <div class="navbar-custom">
    <div class="container-fluid">
      <div class="row">
        <div class="col-6">
          <nav
            style="--bs-breadcrumb-divider: ''"
            aria-label="breadcrumb"
            class="pt-2"
          >
            <div class="breadcrumb">
              <span class="breadcrumb-item">
                <a href="javascript:void(0)">PayEXAP</a>
              </span>
              <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
              <span class="breadcrumb-item" aria-current="page">
                <a routerLink="/credit-notes">Credit Notes</a>
              </span>
              <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
              <span class="breadcrumb-item" aria-current="page">
                <a routerLink="/upload-credit-note">Submit Credit Note</a>
              </span>
              <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
              <span class="breadcrumb-item" aria-current="page">
                <a routerLink="/upload-credit-note">Credit Note Preview</a>
              </span>
            </div>
          </nav>
        </div>
        <div class="col-6">
          <ul class="navbar-nav list-unstyled topnav-menu float-end">
            <li class="nav-item dropdown nav-user">
              <img
                src="https://github.com/mdo.png"
                alt=""
                width="32"
                height="32"
                class="rounded-circle me-2"
              />
              <span
                class="pro-user-name ms-1 dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Bharat Aluminium...
                <!-- <i
                  class="mdi mdi-chevron-down "
                  
                ></i> -->
              </span>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" routerLink="/vendor-profile">
                    <i class="ri-user-3-line"></i>
                    <span class="ml-2">Vendor Profile</span>
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" routerLink="/password-change">
                    <i class="ri-lock-2-line"></i>
                    <span class="ml-2">Reset Password</span>
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" routerLink="/sign-in">
                    <i class="ri-logout-box-line"></i>
                    <span class="ml-2"> Logout</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="content">
    <div class="dashboard-pane">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="pane-header">
                <h4 class="py-4">Submit Credit Note</h4>
              </div>
              <div class="row">
                <div class="col-7">
                  <div class="form-wrapper pb-5">
                    <div class="form-header pb-4">
                      <h6 class="mb-3">Credit Note Details Extracted</h6>
                      <p>Review Credit Note data extracted and submit</p>
                    </div>
                    <form class="invoice-data" action="">
                      <div class="row g-3 align-items-center my-2">
                        <div class="col-3">
                          <label for="inputPassword6" class="col-form-label"
                            >Bar Code No</label
                          >
                        </div>
                        <div class="col-9">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="eg. 2334545567"
                          />
                        </div>
                      </div>

                      <div class="row g-3 align-items-center my-2">
                        <div class="col-3">
                          <label class="col-form-label">Credit Note No</label>
                        </div>
                        <div class="col-9">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="eg. CN34545567"
                          />
                        </div>
                      </div>

                      <div class="row g-3 align-items-center my-2">
                        <div class="col-3">
                          <label class="col-form-label">IRN No.</label>
                        </div>
                        <div class="col-9">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Enter Supplier PO No."
                          />
                        </div>
                      </div>

                      <div class="row g-3 align-items-center my-2">
                        <div class="col-3">
                          <label class="col-form-label"
                            >Credit Note Amount</label
                          >
                        </div>
                        <div class="col-9">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Enter Invoice Number"
                          />
                        </div>
                      </div>

                      <div class="row g-3 align-items-center my-2">
                        <div class="col-3">
                          <label class="col-form-label">Credit Note Date</label>
                        </div>
                        <div class="col-9">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="DD/MM/YY"
                          />
                        </div>
                      </div>

                      <div class="row g-3 align-items-center my-2">
                        <div class="col-3">
                          <label class="col-form-label">Supplier GSTIN</label>
                        </div>
                        <div class="col-9">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="eg DD/MM/YY"
                          />
                        </div>
                      </div>
                    </form>
                    <button
                      (click)="open(validateModal)"
                      class="btn btn-primary right-align"
                    >
                      Validate Credit Note
                    </button>
                  </div>
                </div>
                <div class="col-5">
                  <div class="form-header pb-4">
                    <h6 class="mb-3">Credit Note Preview</h6>
                    <div class="preview-pane">
                      <!-- <img
                        src="../../../../assets/images/sample.png"
                        alt="invoice"
                        class="img-fluid"
                      /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #validateModal let-modal>
  <div class="modal-header pt-2">
    <h4 class="">Declaration</h4>
  </div>

  <div class="modal-body">
    <p class="mb-3">
      Kindly Review and Accept the Following Declaration to Proceed
    </p>
    <ul>
      <li class="mb-3">
        This is a legitimate tax Credit Note with a valid digital signature.
      </li>
      <li class="my-3">
        We provide consent to JSW to validate the digital signature.
      </li>
      <li class="my-3">
        The first 3 pages of this document attached is the Tax Credit Note.
      </li>
      <li class="my-3">
        We have attached all the supporting documents as requested by JSW.
      </li>
      <li class="my-3">
        We agree that JSW can send the Credit Note back in case of validation
        failures.
      </li>
    </ul>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline"
      (click)="modal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button type="button" class="btn btn-white" (click)="acceptDeclaration()">
      Accept & Proceed
    </button>
  </div>
</ng-template>
